"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSCExamMaster = exports.ExamSubjectMaster = exports.ExamTemplates = exports.CourseCategories = exports.CourseValidityOptions = void 0;
exports.CourseValidityOptions = [
    {
        value: "12-months",
        label: "12 Months (365 Days)",
    },
    {
        value: "6-months",
        label: "6 Months (180 Days)",
    },
    {
        value: "4-months",
        label: "4 Months (120 Days)",
    },
];
exports.CourseCategories = [
    {
        category: "Kerala PSC",
        key: "kerala-psc",
        tags: ["10th Level", "12th Level", "Degree Level", "LGS Special Course"],
    },
];
exports.ExamTemplates = [
    {
        templateId: "regular",
        examType: "freestyle",
        title: "",
        description: "",
        totalMarks: 0,
        totalQuestions: 0,
        examDurationInMinutes: 0,
        correctAnswerScore: 1,
        wrongAnswerScore: 0,
        unAnsweredScore: 0,
    },
    {
        templateId: "mock-test",
        examType: "freestyle",
        title: "Mock Tests",
        description: "These are mostly previous year papers. Students can get an idea of what they are going to experience in the final examinations, at the end of this exam. ",
        totalMarks: 100,
        totalQuestions: 100,
        examDurationInMinutes: 75,
        correctAnswerScore: 1,
        wrongAnswerScore: 0.33,
        unAnsweredScore: 0,
    },
    {
        templateId: "revision-test",
        examType: "freestyle",
        title: "Revision Tests",
        description: "The best way to keep hold of what they've learned by giving them frequent revision tests before they attend the final exams. ",
        totalMarks: 40,
        totalQuestions: 40,
        examDurationInMinutes: 30,
        correctAnswerScore: 1,
        wrongAnswerScore: 0.33,
        unAnsweredScore: 0,
    },
];
exports.ExamSubjectMaster = [
    {
        label: "Mathematics",
        value: "maths",
    },
    {
        label: "Physics",
        value: "physics",
    },
    {
        label: "Chemistry",
        value: "chemistry",
    },
    {
        label: "Biology",
        value: "biology",
    },
];
exports.PSCExamMaster = [
    {
        label: 'LD Clerk',
        value: 'ld-clerk'
    },
    {
        label: 'Village Officer',
        value: 'village-officer'
    },
    {
        label: 'LP/UP School Assistant',
        value: 'lp-up-school-assistant'
    },
    {
        label: 'Lab Assistant',
        value: 'lab-assistant'
    },
    {
        label: 'Devaswom Board',
        value: 'devaswom-board'
    },
    {
        label: 'Assistant Prison Officer',
        value: 'assistant-prison-officer'
    },
    {
        label: 'Degree Level',
        value: 'Degree Level'
    },
    {
        label: 'Plus Two Level',
        value: 'Plus Two Level'
    },
    {
        label: '10th Level',
        value: '10th Level'
    }
];
//# sourceMappingURL=masters.js.map